import * as React from "react";
import { IconProps } from "../types";

const OpieOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 16.25C13.0041 16.25 16.25 13.0041 16.25 9C16.25 4.99594 13.0041 1.75 9 1.75C4.99594 1.75 1.75 4.99594 1.75 9C1.75 13.0041 4.99594 16.25 9 16.25Z"
          stroke="#14151A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.749 11C12.032 12.338 10.621 13.25 8.99998 13.25C7.37898 13.25 5.96698 12.338 5.25098 11"
          stroke="#14151A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.159 6.50443L9.896 6.08033L9.475 4.80813C9.338 4.39713 8.663 4.39713 8.526 4.80813L8.105 6.08033L6.842 6.50443C6.638 6.57293 6.5 6.76533 6.5 6.98183C6.5 7.19833 6.638 7.39073 6.842 7.45923L8.105 7.88333L8.526 9.15553C8.594 9.36103 8.786 9.50003 9.001 9.50003C9.216 9.50003 9.407 9.36103 9.476 9.15553L9.897 7.88333L11.16 7.45923C11.364 7.39073 11.502 7.19833 11.502 6.98183C11.502 6.76533 11.363 6.57293 11.159 6.50443Z"
          fill="#14151A"
        />
      </svg>
    );
  },
);

export default OpieOutlineIcon;
